module.exports = " <div _v-11eceb8f=\"\"> <img :src=iconImageSource v-if=iconImageSource _v-11eceb8f=\"\"> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-11eceb8f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderIconImage.vue
// module id = 378
// module chunks = 2